export const loadingSpinnerStyles = {
  containerClass: { padding: '40px' },
  itemClass: { padding: '10px' },
};
